import info from "./information.png";


import { data } from "./responsibilitiesDelegation.data";
import { applicationsData } from "./applications.data";

import deleteIcon from "../../../../../assets/icons/delete_plus.svg";

import Header from "../../../../layout/Header/Header";
import Footer from "../../../../layout/Footer/Footer";
import MultiRoute from "../../../../common/MultiRoute/MultiRoute";

import {
    getActiveDelegationsThunkAction,
} from "../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/thunk/getActiveDelegations.thunk.action";

import {
    clearActiveDelegations,
} from "../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearActiveDelegations.action";
import ModalBanOverlay from "../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import ErrorModal from "../../../../common/Modal/ModalConditions/Profile/ErrorModal/ErrorModal";
import ReplacementModal from "../../../../common/Modal/Replacement/ReplacementModal/ReplacementModal";
import {
    deleteSubstitutionThunkAction,
} from "../../../../../redux/actions/MyDivision/EmployeeList/thunk/deleteSubstitution.thunk.action";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import React, { useEffect } from "react";

import "./ResponsibilitiesDelegation.scss";
import { ClipLoader } from "react-spinners";

const ResponsibilitiesDelegation = () => {
    const dispatch = useDispatch();

    const activeSubstitution = useSelector(state => state.myDivision.activeSubstitution);

    const [statusModal, setStatusModal] = React.useState({ status: false, loading: false,  message: "", delete: false });

    function closeModal() {
        setStatusModal({ status: false, message: "", loading: false, delete: false });
    }
    function deleteSubstitutionStatus(element) {
        if (!statusModal.loading ) {
            console.log(statusModal.loading);
            setStatusModal({...statusModal,
                delete: true,
                loading: false,
                employee: element,
            });
        }
    }
    function deleteSubstitution() {
        setStatusModal({
            ...statusModal,
            loading: true,
            id: statusModal.employee.id,
            delete: false,
        });

        dispatch(deleteSubstitutionThunkAction({id: statusModal.employee.id, statusModal, setStatusModal }));
    }
    function isDateInRange(date, startDate, endDate) {
        const startOfStartDate = new Date(startDate);
        startOfStartDate.setHours(0, 0, 0, 0);

        date.setHours(0, 0, 0, 0);

        const endOfEndDate = new Date(endDate);
        endOfEndDate.setHours(0, 0, 0, 0);

        return date >= startOfStartDate && date <= endOfEndDate;
    }

    useEffect(() => {
        dispatch(getActiveDelegationsThunkAction());
        return()=>{
            dispatch(clearActiveDelegations());
        };
    }, []);

    console.log(activeSubstitution);
    return (
        <>
            <Header />
            <div className={"delegation-of-responsibilities"}>
                <MultiRoute
                    styleParent={"divisions"}
                    subHeader={"Замещение"}
                    breadCrumbs={true}
                    data={data} />
                {/*TODO REFACTOR MULTI-ROUTE! MAX MIN HEIGHT! */}
                <table className="table">
                    <thead>
                        <tr className="table__row">
                            {applicationsData && applicationsData.map((el) => {
                                return (
                                    <th
                                        key={el.id}
                                        style={{ width: `${el.width}` }}
                                        className="table__row__item"
                                    >
                                        {el.title}
                                        {
                                            el.icon
                                                ? <img
                                                    src={el.icon}
                                                    alt="triangle"
                                                    className="header-triangle" />
                                                : null
                                        }
                                    </th>
                                );
                            })
                            }
                        </tr>
                    </thead>
                    {
                        activeSubstitution ?
                            ( activeSubstitution.length > 0  ?
                                <tbody>
                                    {activeSubstitution && activeSubstitution.map((el, i) => (
                                        <tr
                                            key={el.id}
                                            // className={
                                            //     new Date().getDate() >= new Date(el.from).getDate() &&
                                            //     new Date().getDate() <= new Date(el.to).getDate() ?
                                            //         "delegation-of-responsibilities__rows-active" :
                                            //         "delegation-of-responsibilities__rows"
                                            // }
                                            className={
                                                isDateInRange(new Date(), el.from, el.to) ?
                                                    "delegation-of-responsibilities__rows-active" :
                                                    "delegation-of-responsibilities__rows"
                                            }
                                        >
                                            <td style={{ width:  "180px" }}>{el.substitute.fullName}</td>
                                            <td style={{ width:  "150px" }}>{el.substitute.jobTitle}</td>
                                            <td style={{ width:  "450px" }}>{el.substitute.fullStructName}</td>
                                            <td style={{ width:  "108px", textAlign: "center" }}>{moment(el.from).format("DD.MM.YYYY")}</td>
                                            <td  style={{ width:  "108px", textAlign: "center"}}>
                                                {el.to ?  moment(el.to).format("DD.MM.YYYY") : <div style={{fontSize: "26px", fontWeight: "lighter", textAlign: "center"}}>{"\u221E"}</div>  }
                                            </td>
                                            {/*<td*/}
                                            {/*    // onClick={(e) => e.stopPropagation()}*/}
                                            {/*    style={{ width:  "200px" }}>*/}
                                            {/*    {el.comment} {" "}*/}

                                            {/*</td>*/}
                                            <td
                                                // onClick={(e) => e.stopPropagation()}
                                                style={{ width:  "50px" }}>
                                                {
                                                    //  new Date(el.from).getTime() > new Date().getTime()
                                                    ! isDateInRange(new Date(), el.from, el.to)
                                                        ?  (
                                                            <div  id = {el.id}>
                                                                {
                                                                    ( statusModal.loading && statusModal.id === el.id) ?
                                                                        <ClipLoader color={"#6DCDF6"}/> :
                                                                        <img className={"table-img"}
                                                                            onClick={ ()=>deleteSubstitutionStatus(el)}
                                                                            src={deleteIcon} alt="" />
                                                                }
                                                            </div>
                                                        )
                                                        :
                                                        <span className={"popup-notification"}>

                                                            <img style={{opacity: "30%", filter: "grayscale(100%)"}} className={"table-img"}
                                                                // onClick={ ()=>deleteSubstitutionStatus(el)}
                                                                src={deleteIcon} alt="" />
                                                            {/*<img style={{marginLeft: "0px",width: "26px" }} className={"table-img"} src={info} alt="#" />*/}
                                                            <div className="custom-uploader__item__name__label">
                                                                           Данное замещение является действующим и не может быть удалено.
                                                                             При необходимости прекращения замещения скорректируйте его конечную дату.
                                                            </div>
                                                        </span>


                                                }

                                            </td>
                                        </tr>
                                    ))}
                                </tbody> :
                                <div className={"replacement-modal__body"}>
                                    <span style={{opacity:"70%"}}  className={"table__row__item"}>
                                    Замещения отсутствуют
                                    </span>
                                </div>) :
                            <div style={{margin: " 100px auto" , height: "200px", width: "200px"}}>
                                <ClipLoader color={"#6DCDF6"}/>
                            </div>
                    }

                </table>
                <div style={{height: "10vh"}}></div>
            </div>
            <ModalBanOverlay shown={statusModal.status} close={closeModal}>
                <ErrorModal
                    description={statusModal.message}
                    setError={setStatusModal}
                    funk = {deleteSubstitution}
                    route={"/divisions/structure/delegation"}
                    okButton={"удалить"}
                />
            </ModalBanOverlay>
            <ModalBanOverlay shown={statusModal.delete} close={closeModal}>
                <ReplacementModal
                    close={closeModal}
                    proceed={deleteSubstitution}
                    modalData={statusModal.employee}
                />
            </ModalBanOverlay>

            <Footer />
        </>
    );
};

export default ResponsibilitiesDelegation;
